import type { DefaultRootState } from "react-redux";
import type {
  WorkflowRunDetailsData,
  WorkflowRunHistoryData,
} from "ee/reducers/uiReducers/workflowHistoryPaneReducer";

export const getShowRunHistoryPaneState = (state: DefaultRootState) =>
  state.ui.workflowHistoryPane.isOpen;

export const getRunHistorySelectedTab = (state: DefaultRootState) =>
  state.ui.workflowHistoryPane.context.selectedTab;

export const getRunHistoryResponsePaneHeight = (state: DefaultRootState) =>
  state.ui.workflowHistoryPane.context.responseTabHeight;

export const getRunHistoryLoadingState = (state: DefaultRootState) =>
  state.ui.workflowHistoryPane.workflowRunHistory.isLoading;

const DEFAULT_RUN_HISTORY_DATA: Array<WorkflowRunHistoryData> = [];

export const getRunHistoryData = (
  state: DefaultRootState,
  workflowId: string,
) =>
  state.ui.workflowHistoryPane.workflowRunHistory.data?.[workflowId] ||
  DEFAULT_RUN_HISTORY_DATA;

export const getRunHistoryDetailsLoadingState = (state: DefaultRootState) =>
  state.ui.workflowHistoryPane.workflowRunDetails.isLoading;

export const getIsTerminatingWorkflowRun = (state: DefaultRootState) =>
  Boolean(state.ui.workflowHistoryPane.isTerminatingRun);

export const getRunHistoryDetailsData = (
  state: DefaultRootState,
  runId: string,
): WorkflowRunDetailsData | undefined =>
  state.ui.workflowHistoryPane.workflowRunDetails.data.hasOwnProperty(runId)
    ? state.ui.workflowHistoryPane.workflowRunDetails.data[runId]
    : undefined;
